import * as yup from 'yup';

export type DocumentTemplateFormValues = {
    code: string;
    title: string;
    description: string;
    violationType: string;
    kind: string;
    isEnabled: boolean;
};

export type MessageTemplateFormValues = {
    channel: string;
    language: string;
    subject: string;
    bodyContentType: string;
    body: string;
    isEnabled: boolean;
};

type Translate = (key: string, replace?: Record<string, unknown>) => string;

const requiredTrimmed = (message: string) =>
    yup
        .string()
        .transform((value) => String(value ?? '').trim())
        .required(message)
        .test('not-blank', message, (value) => String(value ?? '').trim().length > 0);

export const getDocumentTemplateSchema = (t: Translate, isNewEntity: boolean) =>
    yup.object().shape({
        code: isNewEntity ? requiredTrimmed(t('enter-code')) : yup.string(),
        title: requiredTrimmed(t('enter-title')),
        description: requiredTrimmed(t('enter-description')),
        violationType: requiredTrimmed(t('enter-type')),
        kind: requiredTrimmed(t('enter-kind')),
        isEnabled: yup.boolean().required(),
    });

export const getMessageTemplateSchema = (t: Translate) =>
    yup.object().shape({
        channel: requiredTrimmed(t('enter-channel')),
        language: requiredTrimmed(t('enter-language')),
        subject: requiredTrimmed(t('enter-subject')),
        bodyContentType: requiredTrimmed(t('enter-body-content-type')),
        body: requiredTrimmed(t('enter-body')),
        isEnabled: yup.boolean().required(),
    });
